import { render } from "./BornForm.vue?vue&type=template&id=9e6a32b2&scoped=true"
import script from "./BornForm.vue?vue&type=script&lang=js"
export * from "./BornForm.vue?vue&type=script&lang=js"

import "./BornForm.vue?vue&type=style&index=0&id=9e6a32b2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6a32b2"]])

export default __exports__